import type { Step } from 'react-joyride';

// Pasos del tour onboarding global. Apuntan a elementos del AppShell que
// existen en TODAS las rutas (sidebar + navbar). Así el tour funciona
// aunque el user esté en /products tras el login, sin saltarse pasos por
// targets ausentes.
export const ONBOARDING_STEPS: Step[] = [
  {
    target: '[data-tour="sidebar-nav"]',
    title: 'Bienvenido a Effetá Admin',
    content:
      'Aquí tienes todas las secciones del panel. Te muestro las principales en un recorrido rápido.',
    placement: 'right',
  },
  {
    target: '[data-tour="sidebar-dashboard"]',
    title: 'Inicio',
    content:
      'Métricas generales del catálogo y accesos rápidos a productos, pendientes y sugerencias IA.',
    placement: 'right',
  },
  {
    target: '[data-tour="sidebar-products"]',
    title: 'Productos',
    content:
      'Catálogo central: SKUs, marca, categoría, atributos e imágenes. Filtros, búsqueda y acciones masivas (sobre varios productos a la vez).',
    placement: 'right',
  },
  {
    target: '[data-tour="sidebar-pending"]',
    title: 'Pendientes',
    content:
      'SKUs incompletos (sin marca, categoría o imagen). Aquí los completas uno a uno o en lote.',
    placement: 'right',
  },
  {
    target: '[data-tour="sidebar-ai-suggestions"]',
    title: 'Sugerencias IA',
    content:
      'Inbox de atributos generados con Gemini esperando aprobación. Revísalos para enriquecer el catálogo.',
    placement: 'right',
  },
  {
    target: '[data-tour="navbar-help"]',
    title: 'Ayuda contextual',
    content:
      'Cuando olvides cómo funciona una sección, haz click aquí y elige la sección de la página actual.',
    placement: 'bottom-end',
  },
  {
    target: '[data-tour="navbar-user"]',
    title: 'Tu cuenta',
    content:
      'Tu rol, las preferencias de los tours y "Salir del PIM". Listo, ya puedes empezar a usar el panel.',
    placement: 'bottom-end',
  },
];
